/* eslint-disable no-unused-vars */
import { useState } from "react";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LogoutOutlined,
  BarChartOutlined,
  LineChartOutlined,
  CloudDownloadOutlined
} from "@ant-design/icons";
import { Layout, Menu, Button } from "antd";
const { Header, Sider, Content } = Layout;
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
// import { clearTokenCookie } from "../../utils/constants";
import Logo from "../../Assets/Images/logo.png";
import SteamHomeTreeChart from "../Screens/Steam/SteamHomeTreeChart/SteamHomeTreeChart";
import SteamLiveChart from "../Screens/Steam/SteamHomeTreeChart/SteamLiveModule/SteamLiveTrends/SteamLineChart/SteamLiveChart";

// import MainSteamGauge from "../Steam/SteamGaugeCard/ConvertorStatus";
// import ComparitiveReport from "../Steam/HistoricalModule/ComparitiveReport/ComparitiveReport";
// // import Steam from "../../assets/images/stream copy.png";
// import LiveChart from "../Steam/LiveModule/LiveTrends/LineChart/LiveChart";
// import MeterStatus from "../Steam/LiveModule/MeterStatus/MeterStatus";
// import ComparitiveReport from "../Steam/HistoricalModule/ComparitiveReport/ComparitiveReport";
// import RawData from "../Steam/HistoricalModule/RawData/RawDataGrid/RawData";
// import HistoricalTrends from "../Steam/HistoricalModule/HistoricalTrends/HistoricalTrends";
// import ConsumptionReport from "../Steam/HistoricalModule/ConsumptionReport/ConsumptionReport";
// import ConvertorStatus from "../Steam/SteamGaugeCard/ConvertorStatus";
// import SteamHomeTreeChart from "../chart/SteamHomeTreeChart/SteamHomeTreeChart";
// import MeterStatus from "../Steam/LiveModule/MeterStatus/MeterStatus";
// import RawData from "../Steam/HistoricalModule/RawData/RawDataGrid/RawData";
// import ApexChart from "../Steam/LiveModule/LiveTrends/LineChart/live";

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const items = [
  getItem("Dashboard", "1",<CloudDownloadOutlined />),
  getItem("LiveModule", "2", <LineChartOutlined />, [
    getItem("Live Trends", "sub1"),
    getItem("Meter Status", "sub2"),
    getItem("Convertor Status", "sub3"),
  ]),
  getItem("Historical Module", "3", <BarChartOutlined />, [
    getItem("Comparative Report", "sub4"),
    getItem("Raw Data", "sub5"),
    getItem("Historical Trends", "sub6"),
    getItem("Consumption Report", "sub7"),
  ]),

];

export const NavItems = [
  { path: "/steam-dashboard/home", id: "1" },
  { path: "/steam-dashboard/steam-live-trends", id: "sub1" },
  { path: "/steam-dashboard/steam-meter-status", id: "sub2" },
  { path: "/steam-dashboard/steam-convertor-status", id: "sub3" },
  { path: "/steam-dashboard/comparitive-report", id: "sub4" },
  { path: "/steam-dashboard/raw-data", id: "sub5" },
  { path: "/steam-dashboard/historical-trends", id: "sub6" },
  { path: "/steam-dashboard/consumption-report", id: "sub7" },

];

const SteamLayout = () => {
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState(
    localStorage.getItem("selectedKey") || "2"
  );

  const handleMenuClick = (e) => {
    const clickedKey = e.key;
    setSelectedKey(clickedKey);
    localStorage.setItem("selectedKey", clickedKey);
    const selectedItem = NavItems.find((item) => item.id === clickedKey);
    if (selectedItem) {
      navigate(selectedItem.path);
    }
  };

  const handleLogout = () => {
    clearTokenCookie();
    navigate("/login");
    localStorage.removeItem("selectedKey")
  };

  return (
    <Layout>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={`${collapsed ? "overflow-hidden" : "overflow-auto"
          } h-screen `}
        onCollapse={(value) => setCollapsed(value)}
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          bottom: 0,
          paddingRight: 4,
          paddingLeft: 4,
          background:
            "linear-gradient(165deg, rgba(49,204,17,1) 0%, rgba(23,199,75,1) 3%, rgba(3,18,68,1) 29%)",
        }}
      >
        <div className="demo-logo-vertical text-white text-2xl font-bold flex space-x-2 py-2 mb-4">
          <div
            className={`${collapsed ? "w-14" : "w-14"
              } p-2 ml-2 transition-all duration-300 cursor-pointer`}
            onClick={() => navigate('/landing-page')}
          >
            {!collapsed && <div className="w-40 transition delay-200">
              <img width="100%" height="100%" src={Logo} alt="logo" />
            </div>}
          </div>
          {/* {!collapsed && (
            <p className="flex items-center transition duration-100">
              Tailwind
            </p>
          )} */}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[selectedKey]}
          items={items}
          className="bg-transparent font-bold "
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout className="site-layout">
        <Header className="sticky top-0 w-full bg-blue-900 z-10 shadow-md text-white">
          <i
            onClick={() => setCollapsed(!collapsed)}
            className=" cursor-pointer rounded-lg text-2xl w-8 h-8 absolute top-2 left-3 text-white"
          >
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </i>

          <p className="text-2xl flex justify-center items-center h-16 pr-4 font-bold">
            Steam
          </p>
          <div className="flex flex-col justify-end items-center space-x-4 cursor-pointer font-semibold">
            <p className="absolute -top-4 right-8 font-bold">admin</p>
            <i
              className="text-xl absolute top-5 right-10 cursor-pointer"
              onClick={handleLogout}
            >
              <LogoutOutlined />
            </i>
          </div>
        </Header>
        <Content className="h-full">
          <div className="p-6 bg-slate-100 h-full overflow-auto">
            <Routes>
             <Route path="/" element={<SteamHomeTreeChart />} />
              {/* <Route path="/home" element={<SteamHomeTreeChart />} /> */}

               {/* <Route path="/steam-live-trends" element={<SteamLiveChart />} /> */}
              {/*<Route path="/meter-status" element={<MeterStatus />} />
              <Route path="/convertor-status" element={<ConvertorStatus />} />

              <Route path="/comparitive-report" element={<ComparitiveReport />} />
              <Route path="/raw-data" element={<RawData />} />
              <Route path="/historical-trends" element={<HistoricalTrends />} />
              <Route path="/consumption-report" element={<ConsumptionReport/>} /> 
              <Route path="/meter-status" element={<MeterStatus />} />

              <Route path="/comparitive-report" element={<ComparitiveReport />} />
              <Route path="/raw-data" element={<RawData />} />
              <Route path="/historical-trends" element={<HistoricalTrends />} />   */}
            </Routes>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );``
};
export default SteamLayout;
